export class CommissionTrueUp {
	public contractId: string;
	public contractLocationId: string;
	public parentId: string;
	public agentId: string;
	public purchasingLayerHistoryId: number;
	public contractNum: string;
	public effectiveDate: Date;
	public expirationDate: Date;
	public displayStatus: string;
	public countryName: string;
	public isResidential: boolean;
	public hasAgentSwitch: boolean;
	public units: string;
	public supplierName: string;
	public receivablePayPlan: string;
	public payPlanName: string;
	public parentName: string;
	public agentName: string;
	public isActive: boolean;
	public isFraudulent: boolean;
	public margin: number;
	public totalMargin: number;
	public rate: number;
	public discountFactor: number;
	public useActuals: boolean;
	public commissionDate: Date;
	public totalActualReceivableUsage: number;
	public totalActualReceivableAmount: number;
	public totalActualPaidUsage: number;
	public totalActualPaidAmount: number;
	public totalForecastPaidUsage: number;
	public totalForecastPaidAmount: number;
	public otherTrueUpUsage: number;
	public otherTrueUpAmount: number;
	public trueUpUsage: number;
	public trueUpAmount: number;

	constructor(data?: Partial<CommissionTrueUp>) {
		Object.assign(this, data);
	}
}
